
import BlockedContentImage from '../../components/BlockedContentImage/BlockedContentImage';
import BlockedContentCountdown from '../../components/BlockedContentCountdown/BlockedContentCountdown';

import { BlockingDisplayType } from '../../controllers/Restrictions';

export default function BlockedContent( props) {
  switch( props.blockedOptions.blockingDisplayType) {
    case BlockingDisplayType.Image: return <BlockedContentImage />;
    case BlockingDisplayType.Countdown:
      return <BlockedContentCountdown blockedUntil={props.blockedOptions.blockedUntil} backgroundImageUrl={props.auxiliarData.posterUrl}/>;
    default:
      console.warn( 'layouts::BlockedContent::BlockedContent() - unrecognize blockingDisplayType: ', props.blockedOptions.blockingDisplayType);
      return <div/>;
  }
}
